import { Modal } from 'antd';
import { Container } from '@/ui/layout';
import { Input } from '@/ui/atoms';
import { useTranslation } from 'react-i18next';

export const RejectModal = ({
  active,
  onClose,
  comment,
  setComment,
  error,
  onSubmit,
  disabledButtons
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={active}
      onCancel={onClose}
      okButtonProps={{
        onClick: onSubmit,
        disabled: disabledButtons
      }}
      okText={t('Reject')}
    >
      <Container $marginTop={10} $wide>
        <Input
          label={t('Comment')}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          error={error}
        />
      </Container>
    </Modal>
  );
};
